import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  input,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';
import { addDays, addMonths, addWeeks, DateService, IsoDate, Store } from '@softline/core';
import { SOFTLINE_FEATURE_MODAL } from '@softline/ui-core';
import { ModalStore } from '@softline/ui-core';
import { IconComponent } from '@softline/ui-core';

import { TranslatePipe } from '@softline/ui-core';
import { FormatPipe } from '@softline/ui-core';
import { selectDateFn } from '@softline/ui-core/date-input';
@Component({
  selector: 'soft-date-navigator',
  templateUrl: './date-navigator.component.html',
  styleUrls: ['./date-navigator.component.css'],
  imports: [CommonModule, IconComponent, TranslatePipe, FormatPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateNavigatorComponent implements OnInit {
  @Input() date: IsoDate = this.dateService.now();
  @Output() dateChange = new EventEmitter<IsoDate>();

  flexWrap = input('flex-wrap');
  view = input<'day' | 'week' | 'month'>('day');

  headerContentTemplate = input<TemplateRef<any> | null>(null);

  readonly #datePicker = selectDateFn();

  constructor(
    public dateService: DateService,
    private readonly store: Store
  ) {}

  ngOnInit(): void {
    //
  }

  onChange(date: IsoDate, days = 0): void {
    if (this.view() === 'week') {
      this.date = addWeeks(date, days);
      this.dateChange.emit(this.date);
    } else if (this.view() === 'month') {
      this.date = addMonths(date, days);
      this.dateChange.emit(this.date);
    } else {
      this.date = addDays(date, days);
      this.dateChange.emit(this.date);
    }
  }

  async openDatePickerDialog(): Promise<void> {
    const result = await this.#datePicker({
      value: this.date,
      dismiss: true
    })

    if (!result || result === 'DISMISSED') return;

    this.onChange(result as IsoDate);
  }
}
